var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_399",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29037",
    "data-name": "Group 29037",
    transform: "translate(-4117 4899)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4117, -4899)",
    filter: "url(#Ellipse_399)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_399-2",
    "data-name": "Ellipse 399",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-koo",
    transform: "translate(4132.822 -4885.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50726",
    "data-name": "Path 50726",
    d: "M26.385,4.661c-.049-.558-.334-2.655-1.88-2.946-.37-.07-1.048.345.481,1.448-.167-.125-1.5-1.084-1.792-.1-.07.239-.229.688,1.277,1.105,0,0-1.282-.414-1.343.342a7.9,7.9,0,0,1,3.256.154Z",
    transform: "translate(-2.7)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50727",
    "data-name": "Path 50727",
    d: "M30.53,17.221c-.2-.651-.656-3.335-.656-3.335C29.179,9.4,25.8,6,21.73,6c-4.574,0-8.281,4.294-8.281,9.59,0,.361.023.715.057,1.064a.393.393,0,0,1,.148.043c1.909.971,3.672,4.215,2.931,6.476-.4,1.212-1.563,2.5-4.719,2.5A15.629,15.629,0,0,1,9.6,25.483c-1.783.188-1.378,1.44-1.378,1.44,1.328,3.985,6.191,5.437,8.436,5.9l1.163,3.489h-1.07a.41.41,0,1,0,0,.819h1.469l1.519,1.519a.41.41,0,1,0,.579-.579l-.94-.94h1.469a.41.41,0,1,0,0-.819H18.679l-1.108-3.323c.14.02.236.033.236.033a14.268,14.268,0,0,0,4.929.025l.815,2.447h-1.07a.41.41,0,1,0,0,.819H23.95l1.519,1.519a.41.41,0,1,0,.579-.579l-.94-.94h1.469a.41.41,0,1,0,0-.819H24.415l-.873-2.62a10.422,10.422,0,0,0,6.235-4.567A14.483,14.483,0,0,0,30.53,17.221Z",
    transform: "translate(0 -0.775)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50728",
    "data-name": "Path 50728",
    d: "M16.162,25.466c.618-1.887-.888-4.459-2.293-5.356-1.155,1.627-3.191,4.747-3.718,7.116C13.492,27.7,15.629,27.092,16.162,25.466Z",
    transform: "translate(-0.356 -3.324)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50729",
    "data-name": "Path 50729",
    d: "M36.759,21.48a19.843,19.843,0,0,1-.116,7.273C39.939,28.09,39.434,24.765,36.759,21.48Z",
    transform: "translate(-5.141 -3.571)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_516",
    "data-name": "Ellipse 516",
    cx: 0.819,
    cy: 0.819,
    r: 0.819,
    transform: "translate(20.323 12.599)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_517",
    "data-name": "Ellipse 517",
    cx: 0.819,
    cy: 0.819,
    r: 0.819,
    transform: "translate(26.058 12.599)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50730",
    "data-name": "Path 50730",
    d: "M25.856,18.165l1.254-.619a.206.206,0,0,1,.184,0l1.208.621a.205.205,0,0,1,0,.363l-1.186.635a.2.2,0,0,1-.188,0l-1.276-.637A.2.2,0,0,1,25.856,18.165Z",
    transform: "translate(-3.172 -2.857)",
    fill: "#c62828"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoo);
export default __webpack_public_path__ + "static/media/koo.f18dd995eab0eb1e0c3b53f66c20e909.svg";
export { ForwardRef as ReactComponent };